export default __webpack_public_path__ + "static/media/sena.4df31eb6.png";